export default {
    "html":
    {
        "background": "#1f1f1f!important"
    },
    "root":
    {
        "background": "#1f1f1f!important"
    },
    "a":
    {
        "color": "#fff"
    },
    ".view-all-button": {
        "color": "#fff!important"
    },
    ".chat-item .message": {
        "background": "#303030!important",
        "color": "#fff!important"
    },
    ".chat-item:not(.message) .message": {
        "background": "#004c6b!important",
        "color": "#3dd8fc!important"
    },
    ".inline-edit-input:hover": {
        "background": "#545454!important",
    },
    ".status-circle": {
        "box-shadow": "#121212 0px 0px 0px 4px!important",
    },
    ".googleLogin--wrapper button, .googleLogin--wrapper div": {
        "background-color": "#747272!important",
        "color": "#fff!important",
        "border": "none!important"
    },
    ".simple-input": {
        "color": "#fff",
        "background": "transparent"
    },
    ".chart-root svg>rect": {
        "fill": "#121212"
    },
    ".chart-root svg text": {
        "fill": "#fff"
    },
    ".dark-mode-white": {
        "color": "#fff!important"
    },
    ".chart-root svg .google-visualization-tooltip text": {
        "fill": "#000"
    },
    ".chart-root svg g:nth-of-type(1n) g g:first-of-type rect": {
        "fill": "#848484"
    },
    "a:visited":
    {
        "color": "#fff"
    },
    ".MuiAutocomplete-input":
    {
        "color": "#fff"
    },
    ".MuiInputBase-sizeSmall": {
        "color": "#fff"
    },
    ".MuiAutocomplete-tag":
    {
        "color": "#fff"
    },
    ".MuiFormControlLabel-label":
    {
        "color": "#fff"
    },
    ".single-event-edit .MuiInputBase-root": {
        "color": "#fff!important"
    },
    ".single-event-edit .MuiTextField-root": {
        "background": "#303030!important",
        "color": "#fff!important"
    },
    ".timeline": {
        "color": "#fff!important"
    },
    ".terminal--logs": {
        "background": "#121212!important",
    },
    ".first-purchase-in-list": {
        "background": "#5c5c5c!important"
    },
    ".timeline .codeWrapper": {
        "background": "#515151!important"
    },
    ".MuiTypography-root":
    {
        "color": "#fff!important"
    },
    ".MuiInputBase-input.Mui-disabled":
    {
        "WebkitTextFillColor": "rgba(255, 255, 255, 0.5)!important"
    },
    ".MuiAppBar-colorPrimary":
    {
        "background": "#272727"
    },
    ".MuiInputLabel-shrink":
    {
        "color": "#fff"
    },
    ".MuiInput-underline:hover:not(.Mui-disabled):before":
    {
        "borderBottom": "1px solid #fff"
    },
    ".MuiInput-underline:before":
    {
        "borderBottom": "1px solid #434343"
    },
    ".MuiInputBase-input":
    {
        "color": "#fff"
    },
    ".MuiButton-root":
    {
        "color": "#fff"
    },
    ".json-editor .MuiIconButton-root":
    {
        "color": "#fff"
    },
    ".json-editor .MuiPaper-roo":
    {
        "background": "#303030",
        "color": "#fff"
    },
    ".json-editor textarea":
    {
        "background": "#303030",
        "color": "#fff"
    },
    ".json-editor .pretty-json-container":
    {
        "background": "#fff"
    },
    ".json-editor .MuiTableCell-root":
    {
        "color": "#fff!important"
    },
    ".AuthorizationWrapped-centered-8 p":
    {
        "color": "#fff"
    },
    "input:-webkit-autofill":
    {
        "box-shadow": "#383838 0px 0px 0px 30px inset !important",
        "-webkit-text-fill-color": "#fff",
    },
    "input:-webkit-autofill:hover":
    {
        "box-shadow": "#383838 0px 0px 0px 30px inset !important"
    },
    "input:-webkit-autofill:focus":
    {
        "box-shadow": "#383838 0px 0px 0px 30px inset !important"
    },
    "input:-webkit-autofill:active":
    {
        "box-shadow": "#383838 0px 0px 0px 30px inset !important"
    }
}
